export default __webpack_public_path__ + "static/media/uac.1adfabcd.svg";